// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Contact__wrapper__1EMnt","aboutHeading":"Contact__aboutHeading__1IKuz","form_cont":"Contact__form_cont__3EKW3","button_col":"Contact__button_col__tFmFO","send_e_button":"Contact__send_e_button__1NYuw","contact_info":"Contact__contact_info__2zTP4","dl_vertical":"Contact__dl_vertical__2KHhl","formControl":"Contact__formControl__1zOR6"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Contact/Contact.css
// module id = 46
// module chunks = 0